"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore file */
var RadioTabState = /** @class */ (function () {
    function RadioTabState() {
    }
    return RadioTabState;
}());
exports.default = RadioTabState;
//# sourceMappingURL=RadioTabState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RadioTab/RadioTabState.js
// module id = 1270
// module chunks = 8